<div class="sk-folding-cube" [ngStyle]="foldingCubeSize">
  <div class="sk-cube1 sk-cube"></div>
  <div class="sk-cube2 sk-cube"></div>
  <div class="sk-cube4 sk-cube"></div>
  <div class="sk-cube3 sk-cube"></div>
</div>

@if (size >= 30) {
  <div class="tx-11 text-center" [innerHTML]="title | translate">
  </div>
}
